import React, { useEffect, useRef, useState } from "react"
import { Button, Col, Container, Form, Row, Spinner } from "react-bootstrap"
import { AnimationOnScroll } from 'react-animation-on-scroll'
import emailjs from '@emailjs/browser'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import iconLoc from './../assets/ep_location-information.png'
import iconPhone from './../assets/bi_telephone.png'
import iconFax from './../assets/cil_fax.png'

const MySwal = withReactContent(Swal)

const Contact = () => {
  const formRef = useRef()
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    company: '',
    message: ''
  })
  const [error, setError] = useState({
    name: '',
    phone: '',
    email: '',
    company: '',
    message: ''
  })
  const [checkbox, setCheckbox] = useState(false)

  const submit = () => {
    setLoading(true)

    var mailformat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    var phoneFormat = /^(\+62|62|0)8[1-9][0-9]{6,10}$/; // Validasi nomor Indonesia
    console.log('submit',phoneFormat.test(form.phone))
    if (
      form.name === '' ||
      mailformat.test(form.email) === false ||
      phoneFormat.test(form.phone) === false || // tambahkan validasi phone
      form.message === '' ||
      form.company === ''
    ) {
      if (form.name === '') {
        setError(state => ({ ...state, name: 'Required' }))
      } else {
        setError(state => ({ ...state, name: '' }))
      }
      if (form.phone === '') {
        setError(state => ({ ...state, phone: 'Required' }))
      } else {
        setError(state => ({ ...state, phone: 'Invalid phone number' }))
      }
      if (form.company === '') {
        setError(state => ({ ...state, company: 'Required' }))
      } else {
        setError(state => ({ ...state, company: '' }))
      }
      if (mailformat.test(form.email) === false) {
        setError(state => ({ ...state, email: 'Invalid email address' }))
      } else {
        setError(state => ({ ...state, email: '' }))
      }

      if (form.message === '') {
        setError(state => ({ ...state, message: 'Required' }))
      } else {
        setError(state => ({ ...state, message: '' }))
      }

      console.log('pass',error)
      setLoading(false)
      return false
    }

    setError({
      name: '',
      phone: '',
      email: '',
      company: '',
      message: ''
    })

    emailjs.sendForm(process.env.REACT_APP_SERVICE_ID, process.env.REACT_APP_TEMPLATE_ID, formRef.current, process.env.REACT_APP_PUBLIC_KEY)
      .then((result) => {
        setLoading(false)
        setForm({
          name: '',
          phone: '',
          email: '',
          company: '',
          message: ''
        })
        MySwal.fire({
          title: 'Success',
          text: 'Thank for you for your response',
          icon: 'success',
          confirmButtonColor: '#D6262B'
        })
      }, (error) => {
        setLoading(false)
        MySwal.fire({
          title: 'Failed',
          text: error.text,
          icon: 'error',
          confirmButtonColor: '#D6262B'
        })
      });

  }

  useEffect(() => {
    window.scrollTo({
      top: 0
    })
  }, [])

  return (
    <div className="contact">
      <Container className="pt-5 pb-5">
        <Row style={{ alignItems: 'center' }}>
          <Col xs={12} md={6} className="pe-5 mb-5 position-relative d-flex flex-column" style={{ minHeight: 500 }}>
            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInDown" duration={.8} animatePreScroll={true}>
              <div>
                <h1>Let's Talk About</h1>
                <h1 className="mb-3">Your Next Solution</h1>
                <p className="mb-3">Whether you're looking for cybersecurity solutions, planning a new project or looking to improve your existing systems, we're here to help.</p>
                <p>Talk to our team, ask anything, and let's explore how we can support your business securely and efficiently.</p>
              </div>
            </AnimationOnScroll>
            <div className="office-address-sticky mt-auto">
              <p className="fw-bold">Office Address</p>
              <p>Centennial Tower, 38th Floor, Unit H</p>
              <p>Jl. Gatot Subroto Kav. 24-25</p>
              <p>Jakarta 12930, Indonesia</p>
              <p>Phone: +62 21 2295 8146</p>
              <p>Email: sales@exel-int.com</p>
            </div>
          </Col>

          <Col xs={12} md={6} className="ps-4">
            <AnimationOnScroll animateOnce={true} animateIn="animate__slideInUp" duration={.8} animatePreScroll={true}>
              <div className="form-contact">
                <h2>Got a Question? Let's Start Here</h2>
                <p className="desc mt-4 text-center-mobile">Entrust us with the opportunity to address your challenges by providing customized solutions crafted specifically for your needs.</p>

                <Form className="mt-4" ref={formRef}>
                  <Form.Group className="mb-3">
                    {error.name && <span className="error"><Form.Label><span className="error">{error.name}</span></Form.Label></span>}
                    <Form.Control
                      type="text"
                      placeholder="Type your name"
                      value={form.name}
                      onChange={(event) => setForm(state => ({ ...state, name: event.target.value }))}
                      disabled={loading}
                      name="name"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    {error.phone && <span className="error"><Form.Label><span className="error">{error.phone}</span></Form.Label></span>}
                    <Form.Control
                      type="text"
                      placeholder="Type your phone number"
                      value={form.phone}
                      onChange={(event) => setForm(state => ({ ...state, phone: event.target.value }))}
                      disabled={loading}
                      name="phone"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    {error.email && <span className="error"><Form.Label><span className="error">{error.email}</span></Form.Label></span>}
                    <Form.Control
                      type="email"
                      placeholder="Type your email"
                      value={form.email}
                      onChange={(event) => setForm(state => ({ ...state, email: event.target.value }))}
                      disabled={loading}
                      name="email"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    {error.company && <span className="error"><Form.Label><span className="error">{error.company}</span></Form.Label></span>}
                    <Form.Control
                      type="text"
                      placeholder="Type your company name"
                      value={form.company}
                      onChange={(event) => setForm(state => ({ ...state, company: event.target.value }))}
                      disabled={loading}
                      name="company"
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    {error.message && <span className="error"><Form.Label><span className="error">{error.message}</span></Form.Label></span>}
                    <Form.Control
                      as="textarea"
                      rows={6} placeholder="Type your message"
                      value={form.message}
                      onChange={(event) => setForm(state => ({ ...state, message: event.target.value }))}
                      disabled={loading}
                      name="message"
                    />
                  </Form.Group>
                  <div className="d-flex flex-row gap-3 mb-3">
                    <Form.Check
                      type={'checkbox'}
                      checked={checkbox}
                      onClick={() => setCheckbox(!checkbox)}
                    />
                    <p className="text-justify">By checking this box, i consent to receive insight marketing emails. We respect your privacy and will not share your personal information with any other company, person or identity.</p>
                  </div>
                  <Form.Group className="mb-3">
                    <Button
                      className="btn-submit-blue"
                      style={{ width: '100%' }}
                      disabled={loading || !checkbox}
                      onClick={() => submit()}
                    >
                      {loading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" /> Loading
                        </>
                      ) : (
                        <>Submit</>
                      )}
                    </Button>
                  </Form.Group>
                </Form>
              </div>
            </AnimationOnScroll>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default Contact